"use client";
import Image from "next/image";

const companyInfo = [
  { label: "회사", value: "위즈온협동조합" },
  { label: "주소", value: "대전광역시 중구 중앙로 124, 이화빌딩 2층" },
  { label: "이메일", value: "wezon@wezon.co.kr" },
  { label: "대표번호", value: "042-825-5078" },
];

export function AppFooter() {
  return (
    <div className="bg-black">
      <div className="max-w-full xl:max-w-[1280px] mx-auto flex flex-col px-4 xl:px-0 space-y-10 md:space-y-12 py-14  md:py-18">
        <div className="relative w-20 h-4 md:h-6 flex md:w-28">
          <Image
            src="/assets/images/logo/whiteLogo.svg"
            alt="Symbol Logo"
            fill
            style={{ objectFit: "contain" }}
          />
        </div>

        <div className="flex flex-col space-y-10">
          <ul className="flex flex-col space-y-2 md:space-y-4 mt-1 md:mt-4">
            {companyInfo.map(({ label, value }) => (
              <li key={label} className="flex items-center">
                <p
                  className="md:text-[13px] text-xs tracking-tight text-softGray-70 w-16 md:w-26"
                  style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
                >
                  {label}
                </p>
                <p
                  className="md:text-[13px] text-xs tracking-tight text-softGray-10"
                  style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
                >
                  {value}
                </p>
              </li>
            ))}
          </ul>

          <div className="flex items-center">
            <p
              className="md:text-[13px] text-xs tracking-tight w-20 md:w-26 text-[#7d7d7d]"
              style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
            >
              COPYRIGHT
            </p>
            <p
              className="md:text-[13px] text-xs tracking-tight  text-[#7d7d7d]"
              style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
            >
              ⓒ wezoncoop all rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
